document.addEventListener('DOMContentLoaded', () => {

   /* 
   * Validation of the form of inputs for confirming code input 
   */
   const form = document.querySelector('.wcl-modal-confirm-code');

   if (form) {
      const codeInputs = form.querySelectorAll('.wcl-code-inputs input');
      const confirmButton = form.querySelector('.wcl-js-confirm');
      const errorMessage = form.querySelector('.wcl-message');

      // Function to check if all input fields are filled
      function checkInputs() {
         return Array.from(codeInputs).every(input => input.value.trim() !== '');
      }

      // Function to update the status and error message
      function updateFormErrorMessage() {
         const allFieldsFilled = checkInputs();
         confirmButton.disabled = !allFieldsFilled;
         errorMessage.textContent = allFieldsFilled ? '' : multilanguage_object['Please fill in all fields.'];
      }

      codeInputs.forEach((input, index, inputs) => {
         input.addEventListener('input', () => {
            if (input.value.length > 1) {
               input.value = input.value.slice(0, 1);
            }

            if (input.value.length === 1 && index < inputs.length - 1) {
               inputs[index + 1].focus();
            }

            // Check if all fields are filled in before updating the error
            if (checkInputs()) {
               updateFormErrorMessage();
            }
         });

         input.addEventListener('paste', (event) => {

            let pasteData = event.clipboardData.getData('text');

            // Clear non-digit characters
            pasteData = pasteData.replace(/\D/g, '');

            // Distribute pasted data into inputs
            for (let i = 0; i < Math.min(pasteData.length, inputs.length - index); i++) {
               inputs[index + i].value = pasteData[i];
            }

            // Move focus to the next input after the last one filled
            if (index + pasteData.length < inputs.length) {
               inputs[index + pasteData.length].focus();
            }

            // Focus on the last input after pasting
            inputs[index + Math.min(pasteData.length, inputs.length - index) - 1].focus();

            // Check if all fields are filled in before updating the error
            if (checkInputs()) {
               updateFormErrorMessage();
            }
         });

         input.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft' && index > 0) {
               inputs[index - 1].focus();
            } else if (event.key === 'ArrowRight' && index < inputs.length - 1) {
               inputs[index + 1].focus();
            } else if (event.key === 'Backspace' && index > 0 && input.value === '') {
               inputs[index - 1].focus();
            }
         });

         input.addEventListener('keypress', (event) => {
            if (!/\d/.test(event.key) || input.value.length >= 1) {
               event.preventDefault();
            }
         });
      });

      // Adding a click event handler for the confirmation button
      confirmButton.addEventListener('click', () => {
         updateFormErrorMessage();
      });
   }

   /* 
   * Adding a click event handler for "I'll do this later" button for Confirm Email
   */
   const confirmEmailLaterButton = document.getElementById('wcl-js-confirm-later-code');

   if (confirmEmailLaterButton) {
      confirmEmailLaterButton.addEventListener('click', () => {
         const modalForm = confirmEmailLaterButton.closest('.wcl-modal-layout');

         if (modalForm) {
            window.location.reload();
         }
      });
   }
});